module.exports = __webpack_public_path__ + "img/kolecko1.bc680724.svg";